module.exports = __webpack_public_path__ + "img/node-application.ea26f43e.svg";